namespace TabAurous.Common {
    export interface MarkUpResponseEntity {
        MarkUp?: number;
        MarkUpRateType?: number;
    }
}
